module.exports = __webpack_public_path__ + "img/logo-siga.03e5453c.svg";